(function ($, Drupal, drupalSettings) {
  Drupal.behaviors.tipiBootstrapTheme = {
    attach: function (context, settings) {
      $('a[href="/message-modal/open?type=council_tax"]').each(function () {
        var href = $(this).attr('href');
        $(this).attr('href', href + '&screen=' + ((window.innerWidth < 768) ? 'mobile' : 'desktop' ));
      });

      $('input[type="hidden"][name="pardot_visitor_id"]').each(function () {
        const pardotUID = TipiThemeGetCookie("visitor_id506241");
        $(this).val(pardotUID).change().blur();
      });

      if (TipiThemeGetCookie("gtm_custom_cookie")) {
        // console.log('the gtm cookie now works');
        window.dataLayer.push({
          event: "tipi_ajax_form_submission",
        });
        document.cookie =
          "gtm_custom_cookie=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      }

      // Replace the drupal error messages except the partner's enquire form,
      // we are using the error message content to show error modal on partner's enquire form page.
      if ($('article[about$="/partners/enquire-about-unit"]').length === 0) {
        $("div[data-drupal-messages] div[role=alert]").each(function () {
          $(this)
            .contents()
            .filter(function () {
              return this.nodeType == 3 && this.textContent.trim().length;
            })
            .replaceWith(
              "Sorry, we found a little problem with your selection. Please update the relevant field below and try again."
            );
        });
      }

      // selecty for material style select boxes
      $("select.selecty").each(function () {
        if (!$(this).hasClass("selecty-enabled")) {
          $(this).addClass("selecty-enabled");
          $(this).selecty();
        }
      });

      // Book a viewing populate hidden dropdown on min/max rent change
      $(".js-form-item-rent-min .selecty .selecty-options li").click(
        function () {
          // $('.js-form-item-rent-min')
          $(".js-form-item-rent-min .a-dropdown").val("");
        }
      );
      $(".js-form-item-rent-max .selecty .selecty-options li").click(
        function () {
          // $('.js-form-item-rent-min')
          $(".js-form-item-rent-max .a-dropdown").val("");
        }
      );

      $(".o-modal.cta-modal").on("show.bs.modal", context, function (e) {
        // pull through the filters
        // tipi_dynamic__unit_name

        const triggeringElement = $(e.relatedTarget);
        var parentUnitCard = triggeringElement.closest(".o-unit-search-card");

        if (settings.tipi.node_type == "unit") {
          $(this)
            .find('input[name="tipi_dynamic__unit_name"]')
            .val(settings.tipi.node_title);
          $(this)
            .find("span.tipi_dynamic__unit_name")
            .text(settings.tipi.node_title);
          const unitDataMarkup = settings.tipi.unit_markup;
          $(this)
            .find(".m-block-content.m-modal-panel.form-wrapper.unit-details")
            .remove();
          $(unitDataMarkup).insertBefore(
            $(this)
              .find(
                ".m-modal-header + .form-elements.form-wrapper .m-block-content"
              )
              .first()
          );
          $(this)
            .find(".m-block-content.m-modal-panel.form-wrapper.unit-details")
            .next(".m-block-content")
            .hide();
        } else if (
          settings.tipi.node_type == "building_marketing_page" ||
          settings.tipi.node_type == "page"
        ) {
          if (
            settings.tipi.node_type == "building_marketing_page" ||
            settings.tipi.node_type == "page"
          ) {
            if (!parentUnitCard) {
              parentUnitCard = triggeringElement.closest(".o-unit-search-card");
            }
            if (parentUnitCard.length) {
              $(this)
                .find('input[name="tipi_dynamic__unit_name"]')
                .val(parentUnitCard.find(".a-unit-title a").text());
              $(this)
                .find("span.tipi_dynamic__unit_name")
                .text(parentUnitCard.find(".a-unit-title a").text());
              // if ($(this).find('span.tipi_dynamic__unit_name').text().indexOf("Madison") >= 0) {
              //   $(this).find('input[name="building"][value="Madison"]').attr('checked', 'checked');
              // } else if ($(this).find('span.tipi_dynamic__unit_name').text().indexOf("Landsby") >= 0) {
              //   $(this).find('input[name="building"][value="Landsby"]').attr('checked', 'checked');
              // } else if ($(this).find('span.tipi_dynamic__unit_name').text().indexOf("Montana & Dakota") >= 0) {
              //   $(this).find('input[name="building"][value="Montana & Dakota"]').attr('checked', 'checked');
              // } else if ($(this).find('span.tipi_dynamic__unit_name').text().indexOf("Alto") >= 0) {
              //   $(this).find('input[name="building"][value="Alto"]').attr('checked', 'checked');
              // } else if ($(this).find('span.tipi_dynamic__unit_name').text().indexOf("Alameda") >= 0) {
              //   $(this).find('input[name="building"][value="Alameda"]').attr('checked', 'checked');
              // } else if ($(this).find('span.tipi_dynamic__unit_name').text().indexOf("Ferrum") >= 0) {
              //   $(this).find('input[name="building"][value="Ferrum"]').attr('checked', 'checked');
              // } else if ($(this).find('span.tipi_dynamic__unit_name').text().indexOf("Beton") >= 0) {
              //   $(this).find('input[name="building"][value="Beton"]').attr('checked', 'checked');
              // } else if ($(this).find('span.tipi_dynamic__unit_name').text().indexOf("Canada Gardens") >= 0) {
              //   $(this).find('input[name="building"][value="Canada Gardens"]').attr('checked', 'checked');
              // } else if ($(this).find('span.tipi_dynamic__unit_name').text().indexOf("The Robinson") >= 0) {
              //   $(this).find('input[name="building"][value="The Robinson"]').attr('checked', 'checked');
              // }
              const building = parentUnitCard.data("building");
              const rent = parentUnitCard.data("rent");
              const rooms = parentUnitCard.data("beds");

              const minRent = Math.floor(rent / 100) * 100;
              const maxRent = minRent + 100;

              $(this)
                .find('input[name="building"][value="' + building + '"]')
                .attr("checked", "checked");

              document.getElementById("edit-rent-min--4").value = minRent;
              document
                .querySelector("#edit-rent-min--4 option")
                .removeAttribute("selected");
              document
                .querySelector(
                  '#edit-rent-min--4 option[value="' + minRent + '"]'
                )
                .setAttribute("selected", "selected");
              document
                .querySelector("#edit-rent-min--4+.selecty .selecty-options li")
                .classList.remove("selected");
              document
                .querySelector(
                  '#edit-rent-min--4+.selecty .selecty-options li[data-value="' +
                    minRent +
                    '"]'
                )
                .classList.add("selected");
              document.querySelector(
                "#edit-rent-min--4+.selecty .selecty-selected"
              ).innerHTML = minRent + " pcm";

              document.getElementById("edit-rent-max--4").value = maxRent;
              document
                .querySelector("#edit-rent-max--4 option")
                .removeAttribute("selected");
              document
                .querySelector(
                  '#edit-rent-max--4 option[value="' + maxRent + '"]'
                )
                .setAttribute("selected", "selected");
              document
                .querySelector("#edit-rent-max--4+.selecty .selecty-options li")
                .classList.remove("selected");
              document
                .querySelector(
                  '#edit-rent-max--4+.selecty .selecty-options li[data-value="' +
                    maxRent +
                    '"]'
                )
                .classList.add("selected");
              document.querySelector(
                "#edit-rent-max--4+.selecty .selecty-selected"
              ).innerHTML = maxRent + " pcm";

              if (parseInt(rooms) === 0) {
                document.getElementById(
                  "edit-bedrooms-studio--4"
                ).checked = true;
              } else if (parseInt(rooms) === 1) {
                document.getElementById(
                  "edit-bedrooms-1-bed--4"
                ).checked = true;
              } else if (parseInt(rooms) === 2) {
                document.getElementById(
                  "edit-bedrooms-2-bed--4"
                ).checked = true;
              } else if (parseInt(rooms) === 3) {
                document.getElementById(
                  "edit-bedrooms-3-bed--4"
                ).checked = true;
              } else if (parseInt(rooms) === 4) {
                document.getElementById(
                  "edit-bedrooms-4-bed--4"
                ).checked = true;
              }
            }
          }
        } else {
          // have we clicked on book a viewing on a search result?
          if (!parentUnitCard.length)
            parentUnitCard = triggeringElement.closest(
              ".o-apartment-search-card"
            );
          if (parentUnitCard.length) {
            $(this)
              .find('input[name="tipi_dynamic__unit_name"]')
              .val(
                parentUnitCard
                  .find('.meta div[data-key="unit-title"]')
                  .attr("data-value")
              );
            $(this)
              .find("span.tipi_dynamic__unit_name")
              .text(
                parentUnitCard
                  .find('.meta div[data-key="unit-title"]')
                  .attr("data-value")
              );
            // place the unit data into the form
            const unitDataMarkup = parentUnitCard
              .find(".meta .unit-form-markup")
              .html();
            $(this)
              .find(".m-block-content.m-modal-panel.form-wrapper.unit-details")
              .remove();
            $(unitDataMarkup).insertBefore(
              $(this)
                .find(
                  ".m-modal-header + .form-elements.form-wrapper .m-block-content"
                )
                .first()
            );
            $(this)
              .find(".m-block-content.m-modal-panel.form-wrapper.unit-details")
              .next(".m-block-content")
              .hide();
          }
        }

        const searchFilters = JSON.parse(localStorage.getItem("tipi-filters"));
        if (typeof searchFilters != "undefined" && searchFilters != null) {
          // tipi_filter__has_parking
          const parking =
            typeof searchFilters[".has-parking"] != "undefined"
              ? searchFilters[".has-parking"]
              : false;
          if (parking)
            $(this).find('input[name="tipi_filter__has_parking"]').val(parking);
          // tipi_filter__has_storage
          const storage =
            typeof searchFilters[".has-storage"] != "undefined"
              ? searchFilters[".has-storage"]
              : false;
          if (storage)
            $(this).find('input[name="tipi_filter__has_storage"]').val(storage);
          // tipi_filter__has_pets
          const pets =
            typeof searchFilters[".has-pets"] != "undefined"
              ? searchFilters[".has-pets"]
              : false;
          if (pets)
            $(this).find('input[name="tipi_filter__has_pets"]').val(pets);
          // tipi_filter__has_terrace
          const terrace =
            typeof searchFilters[".has-terrace"] != "undefined"
              ? searchFilters[".has-terrace"]
              : false;
          if (terrace)
            $(this).find('input[name="tipi_filter__has_terrace"]').val(terrace);
          // tipi_filter__has_balcony
          const balcony =
            typeof searchFilters[".has-balcony"] != "undefined"
              ? searchFilters[".has-balcony"]
              : false;
          if (balcony)
            $(this).find('input[name="tipi_filter__has_balcony"]').val(balcony);
          // tipi_filter__has_gym
          const gym =
            typeof searchFilters[".has-balcony"] != "undefined"
              ? searchFilters[".has-gym"]
              : false;
          if (gym) $(this).find('input[name="tipi_filter__has_gym"]').val(gym);
          // tipi_filter__furnished_yes
          const furnished =
            typeof searchFilters[".furnished-yes"] != "undefined"
              ? searchFilters[".furnished-yes"]
              : false;
          if (furnished)
            $(this)
              .find('input[name="tipi_filter__furnished_yes"]')
              .val(furnished);
          // rent
          const rentMin =
            typeof searchFilters[".rent-min"] != "undefined"
              ? searchFilters[".rent-min"]
              : false;
          const rentMax =
            typeof searchFilters[".rent-max"] != "undefined"
              ? searchFilters[".rent-max"]
              : false;
          if (rentMin) {
            $(this)
              .find('select[name="rent_min"] option[value="' + rentMin + '"]')
              .attr("selected", "selected");
            $(this)
              .find('select[name="rent_min"]')
              .next(".selecty")
              .find('.selecty-options li[data-value="' + rentMin + '"]')
              .addClass("selected");
            $(this)
              .find('select[name="rent_min"]')
              .next(".selecty")
              .find(".selecty-selected")
              .text(
                $(this)
                  .find('select[name="rent_min"]')
                  .next(".selecty")
                  .find('.selecty-options li[data-value="' + rentMin + '"]')
                  .text()
              );
          }
          if (rentMax) {
            $(this)
              .find('select[name="rent_max"] option[value="' + rentMax + '"]')
              .attr("selected", "selected");
            $(this)
              .find('select[name="rent_max"]')
              .next(".selecty")
              .find('.selecty-options li[data-value="' + rentMax + '"]')
              .addClass("selected");
            $(this)
              .find('select[name="rent_max"]')
              .next(".selecty")
              .find(".selecty-selected")
              .text(
                $(this)
                  .find('select[name="rent_max"]')
                  .next(".selecty")
                  .find('.selecty-options li[data-value="' + rentMax + '"]')
                  .text()
              );
          }
        }
      });
    },
  };
})(jQuery, Drupal);
